var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnayliticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    width: 19,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 19,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAAXNSR0IB2cksfwAAAMZQTFRFAj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+xUQH/wAAAEJ0Uk5TRtDt6errqx7W/4zv+PH8p/Z9NrTyUACb9f3zWaF0SdUvv8JdrGFyNVigZ3f0wVacZHP5lXHe+mjOsHa5qK9rqqkK53uNBQAAAJdJREFUeJx10GkXgUAYhuEXLSaTEl4jkT37vkvy//8Ux2mczHB/es718QHIZHOpFFXTIU/EDChIpoGSLGoWk2Vxs0tOWbRKFWtfRlndbaCXNtps+Uwwt40dWzDmYPeveb2+ZAMcfix42QjHZIJTbrMA52yBS7LCNbfNdrc/WMcTOV+ub1OlD0Iwf/xykywC3biHqeI4ejwBp8UYFZ4Dkn4AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnayliticsIcon);
export default __webpack_public_path__ + "static/media/anayliticsIcon.6fbbda142e226085bf12f1671e811e7d.svg";
export { ForwardRef as ReactComponent };